<template>
  <div>
    <title-products title="Categoria de Produtos"></title-products>
    <view-product-category></view-product-category>
    <open-edit-product></open-edit-product>
    <open-delete-product></open-delete-product>
    <open-add-product-category></open-add-product-category>
    <open-append-product-to-category></open-append-product-to-category>
  </div>
</template>

<script>
import Title from "../geral/Title";
import OpenEditProduct from "./tools/OpenEditProduct";
import OpenDeleteProduct from "./tools/OpenDeleteProduct";
import OpenAddProductCategory from "./category/OpenAddProductCategory";
import ViewProductCategory from "./category/ViewProductCategory";
import OpenAppendProductToCategory from "./category/OpenAppendProductToCategory";
export default {
  name: "ProductCategory",
  components: {
    OpenAppendProductToCategory,
    ViewProductCategory,
    OpenAddProductCategory,
    OpenDeleteProduct,
    OpenEditProduct,

    "title-products": Title
  }
};
</script>

<style scoped></style>
